import { useState } from "react";
import { AlertTriangle, Loader2, Settings2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, fmtDate } from "@/lib/api";

export const PortalButton = ({ variant = "default", label = "Gérer mon abonnement" }) => {
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <Button variant={variant} onClick={open} disabled={busy} data-testid="billing-portal-btn">
      {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Settings2 className="h-4 w-4 mr-2" />}{label}
    </Button>
  );
};

export const PaymentIssue = ({ billing }) => (
  <div className="rounded-lg border border-red-200 bg-red-50 p-5 mb-6" data-testid="billing-payment-issue">
    <p className="flex items-center gap-2 font-semibold text-red-800"><AlertTriangle className="h-5 w-5" />Paiement refusé</p>
    <p className="text-sm text-red-800/90 mt-1 mb-4">
      Le dernier prélèvement n'a pas abouti. Stripe réessaie automatiquement ; mettez à jour votre carte pour éviter la coupure
      {billing.grace_until ? ` des connexions le ${fmtDate(billing.grace_until)}` : ""}.
    </p>
    <PortalButton label="Mettre à jour ma carte" />
  </div>
);
